import {
  ClientUserEmailField,
  ClientUserNameField,
  ClientUserPhoneField,
} from '@src/clientUser/manage/ClientUserFormInputs';
import * as yup from 'yup';

export const AddClientUserFormInputs = yup
  .object()
  .shape({
    [ClientUserNameField.fieldName]: ClientUserNameField.validator,
    [ClientUserEmailField.fieldName]: ClientUserEmailField.validator,
    [ClientUserPhoneField.fieldName]: ClientUserPhoneField.validator,
  })
  .required();
